<template>
	<div>
		<el-alert
			:closable="false"
			show-icon
			title="增值税电子普通发票的法律效力、基本用途、基本使用规定等与税务局监制的增值税普通发票相同"
			type="warning"></el-alert>
		<avue-form ref="avue_content" v-model="formInvoice" :option="optionInvoice" @submit="submitInvoice">
			<el-select
				v-if="supportSpecial"
				slot="invoiceType"
				v-model="formInvoice.invoiceType"
				:disabled="isSubmitted || isInvoiceDisabled"
				@change="typeChanged">
				<el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
			</el-select>
			<el-select
				v-else
				slot="invoiceType"
				v-model="formInvoice.invoiceType"
				:disabled="isSubmitted || isInvoiceDisabled"
				@change="typeChanged">
				<el-option
					v-for="item in typeListNoSpecial"
					:key="item.value"
					:label="item.label"
					:value="item.value"></el-option>
			</el-select>
			<span slot="money">{{ formInvoice.money }}元</span>
			<span slot="title">{{ formInvoice.title }}</span>
			<template slot="menuForm">
				<el-button v-if="isSubmitted" icon="el-icon-edit" @click="modifyInvoice">修改</el-button>
			</template>
		</avue-form>
	</div>
</template>

<script>
import {rule} from '@/util/validateRules'
import {getAreaList, getInvoiceInfo} from '@/api/insurance/policy'
import {getAddressMyList} from '@/api/insurance/product'
import {mapGetters} from 'vuex'
import {isFgkZhuanpiao, isRenBao} from '@/util/productUtil'

export default {
	name: 'InvoiceForm',
	props: {
		supportSpecial: {
			type: Boolean,
			default: true,
		},
		insureType: {
			type: String | Number,
			default: -1,
		},
	},
	computed: {
		...mapGetters(['userInfo', 'permissions']),
		//insureType 6 和21 ，上海太保去掉其他参数！！！！
		isZhuanPiaoHide() {
			return isFgkZhuanpiao(this.insureType)
		},
	},
	data() {
		return {
			optionInvoice: {
				submitBtn: true,
				submitText: '确认',
				emptyBtn: false,
				menuBtn: true,
				labelWidth: '25%',
				column: [
					{
						label: '开票类型',
						prop: 'invoiceType',
						span: 12,
						slot: true,
						disabled: false,
						rules: [
							{
								required: true,
								message: '请选择开票类型',
								trigger: 'change',
							},
						],
					},
					{
						label: '开票金额',
						prop: 'money',
						span: 12,
						slot: true,
						placeholder: ' ',
						disabled: true,
					},
					{
						label: '纳税人识别号',
						prop: 'identification',
						placeholder: '请填写 纳税人识别号',
						span: 12,
						rules: [
							{
								required: true,
								validator: rule.validatorCreditCode,
								trigger: 'blur',
							},
						],
						display: true,
					},
					{
						label: '身份证号',
						prop: 'identification',
						placeholder: '请填写 身份证号',
						span: 12,
						display: false,
					},
					{
						label: '发票抬头',
						prop: 'title',
						span: 12,
						slot: true,
						placeholder: ' ',
						disabled: true,
					},
				],
				group: [
					{
						display: false,
						arrow: false,
						column: [
							{
								label: '注册地址',
								prop: 'address',
								placeholder: '请填写 税务登记详细地址',
							},
							{
								label: '注册电话',
								prop: 'phone',
								placeholder: '请填写 税务登记联系电话',
							},
							{
								label: '开户银行',
								prop: 'bankName',
								placeholder: '请填写 税务登记开户银行',
							},
							{
								label: '开户账号',
								prop: 'bankNo',
								placeholder: '请填写 税务登记开户行账号',
							},
							{
								label: '收件人',
								prop: 'mailName',
								disabled: false,
								placeholder: '请填写 收件人姓名',
							},
							{
								label: '手机号',
								prop: 'mailPhone',
								disabled: false,
								placeholder: '请填写 收件人手机号',
								rules: [
									{
										validator: rule.validatorMobile,
										trigger: 'blur',
									},
								],
							},
							{
								label: '收件人地址',
								type: 'cascader',
								disabled: false,
								prop: 'mailAreaCodeArray',
								props: {
									label: 'areaName',
									value: 'areaCode',
								},
								dicData: [],
								// dicUrl: `/dist/area/list/3`,
								// dicMethod: 'get',
								filterable: true,
								showAllLevels: true,
							},
							{
								label: '详细地址',
								prop: 'mailAddress',
								disabled: false,
								placeholder: '请填写 收件人详细地址',
							},
							{
								label: '纳税人资质证明',
								type: 'upload',
								prop: 'taxCertificate',
								span: 12,
								listType: 'picture-img',
								action: '/dist/distInsure/uploadFile',
								dragFile: true,
								propsHttp: {
									res: 'data',
								},
							},
							{
								label: '示例',
								prop: 'example1',
								type: 'upload',
								span: 6,
								listType: 'picture-img',
								propsHttp: {
									res: 'data',
								},
								disabled: true,
							},
							{
								label: '',
								prop: 'example2',
								type: 'upload',
								span: 4,
								listType: 'picture-img',
								propsHttp: {
									res: 'data',
								},
								disabled: true,
							},
						],
					},
				],
			},
			formInvoice: {
				invoiceType: '',
				money: 0,
				identification: '',
				title: '',
				address: '',
				phone: '',
				bankName: '',
				bankNo: '',
				mailName: '',
				mailPhone: '',
				mailAreaCodeArray: [],
				mailAddress: '',
				taxCertificate: '',
				example1: 'images/tax_ex1.png',
				example2: 'images/tax_ex2.png',
			},
			isSubmitted: false,
			typeList: [
				{
					label: '增值税普票',
					value: 2,
				},
				{
					label: '增值税专票',
					value: 1,
				},
			],
			typeListNoSpecial: [
				{
					label: '增值税普票',
					value: 2,
				},
			],
			//是不是自己填写的邮寄地址
			isSelfInput: true,
			//控制是否可以点击发票
			isInvoiceDisabled: false,
		}
	},
	watch: {
		insureType: {
			handler(newVal = '', oldVal) {
				if (newVal) {
					if (isRenBao(newVal)) {
						//人保
						this.formInvoice.invoiceType = 2
						this.optionInvoice.column[0].disabled = true
						this.optionInvoice.column[2].display = false
						this.optionInvoice.column[3].display = false
					}
				}
			},
			immediate: true,
		},

		'formInvoice.title'(val) {
			if (this.insureType === 29) {
				this.optionInvoice.column[2].display = false
				this.optionInvoice.column[3].display = false
				this.formInvoice.invoiceType = 2
			} else {
				if (val === '个人') {
					this.optionInvoice.column[2].display = false
					this.optionInvoice.column[3].display = true
				} else {
					this.optionInvoice.column[2].display = true
					this.optionInvoice.column[3].display = false
				}
			}
		},

		'formInvoice.identification': {
			handler(newVal, oldVal) {
				if (!this.validatenull(newVal)) {
					let query = {
						unitCode: this.formInvoice.identification,
					}
					getInvoiceInfo(query)
						.then((response) => {
							let invoice = response.data.data.invoice

							if (!this.validatenull(invoice)) {
								let {money = 0, mailAddress, mailName, mailPhone} = invoice
								invoice.orderId = ''
								invoice.title = this.formInvoice.title
								if (!this.validatenull(this.formInvoice.mailAddress) && this.formInvoice.mailAddress !== mailAddress) {
									this.$delete(invoice, 'mailAddress')
								}
								if (!this.validatenull(this.formInvoice.mailName) && this.formInvoice.mailName !== mailName) {
									this.$delete(invoice, 'mailName')
								}
								if (!this.validatenull(this.formInvoice.mailPhone) && this.formInvoice.mailPhone !== mailPhone) {
									this.$delete(invoice, 'mailPhone')
								}

								// let tempData = {
								//   orderId: '',
								//   title: this.formInvoice.title
								// }
								// if (this.formInvoice.money === 0 && (!this.validatenull(invoice.money) && invoice.money > 0)) {
								//   tempData.money = 0
								// }
								//  接口返回可能有脏数据
								// Object.assign(invoice, tempData)
								if (this.formInvoice.money > 0 || money > 0) {
									this.$delete(invoice, 'money')
								} else {
									invoice.money = 0
								}
								//合并数据
								Object.assign(this.formInvoice, invoice)
								if (!this.validatenull(invoice.mailAreaCode)) {
									this.formInvoice.mailAreaCodeArray = this.convertAreaCode(invoice.mailAreaCode)
								}
							} else {
								if (!this.validatenull(oldVal)) {
									let emptyProps = {
										address: '',
										phone: '',
										bankName: '',
										bankNo: '',
										taxCertificate: '',
									}
									Object.assign(this.formInvoice, emptyProps)
								}
							}
						})
						.catch(() => {})
						.finally(() => {})
				}
			},
		},
	},
	created() {
		this.init()
	},
	mounted() {
		this.$nextTick(() => {
			if (this.$refs.avue_content) {
				this.$refs.avue_content.init()
			}
		})
		this.$Bus.$on('taxType', this.onDealTaxType)
	},
	activated() {
		this.$Bus.$on('taxType', this.onDealTaxType)
	},
	deactivated() {
		this.$Bus.$off('taxType')
	},
	methods: {
		init() {
			getAreaList(3).then((response) => {
				this.optionInvoice.group[0].column.forEach((columnData) => {
					if (columnData.prop === 'mailAreaCodeArray') {
						columnData.dicData = response.data.data
					}
				})
			})
		},
		submitInvoice(form, done) {
			let type = null
			this.typeList.forEach((item, index) => {
				if (item.value == form.invoiceType) {
					type = item.label
				}
			})
			if (form.invoiceType == 1 && !this.isZhuanPiaoHide) {
				if (!this.validatenull(form.$mailAreaCodeArray)) {
					let areaArr = form.$mailAreaCodeArray.split('|')
					if (areaArr.length == 3) {
						this.formInvoice.province = areaArr[0].trim()
						this.formInvoice.city = areaArr[1].trim()
						this.formInvoice.district = areaArr[2].trim()
					}
				}
			}
			let hint = isRenBao(this.insureType)
				? '本保险仅出具电子普票，不支持开具“增值税专用发票”。电子发票效力等同于纸质发票，报销可将电子发票打印后直接报销。'
				: '<div>应保险公司要求，开票类型提交后将无法变更。</div><div>当前开票类型：<span style="color:red; font-weight:bold">' +
					type +
					'</span>。</div><div>是否确认按此类型开票？</div>'

			this.$confirm(hint, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				dangerouslyUseHTMLString: true,
				type: 'warning',
			})
				.then(() => {
					this.$message({
						message: '确认 成功',
						type: 'success',
					})

					this.lockForm(true)
					this.$emit('onSubmitted', this.getSubmitData())
					done()
				})
				.catch(() => {
					done()
				})
		},
		modifyInvoice() {
			this.lockForm(false)
			this.$emit('onUnsubmitted')
		},
		lockForm(disabled) {
			this.optionInvoice.submitBtn = !disabled
			this.optionInvoice.column.forEach((item) => {
				item.disabled = disabled
			})
			if (this.formInvoice.invoiceType == 1 && !this.isZhuanPiaoHide) {
				this.optionInvoice.group[0].column.forEach((item) => {
					//不是自己填写的，则不给输入
					let {prop} = item
					if (
						this.isSelfInput ||
						(prop !== 'mailName' && prop !== 'mailPhone' && prop !== 'mailAreaCodeArray' && prop !== 'mailAddress')
					) {
						item.disabled = disabled
					}
				})
			}
			this.isSubmitted = disabled
		},
		async typeChanged(val, isClick = true) {
			//新需求，判断是否为泛高空，接保司通知，因上海疫情管控，即日起至2022年4月5号24时期间，暂停专票与特殊变更普票的申请，请选择普票
			//新需求，上海太保泛高空和电梯，隐藏数据！！！！！！！
			if (this.isZhuanPiaoHide) {
				return
			}
			if (val === 1) {
				//发票新需求
				//根据请求获取邮寄地址
				let myListResult = await getAddressMyList()
				if (myListResult.data && myListResult.data.code === 0) {
					let {data = []} = myListResult.data
					if (data.length > 0) {
						//说明存在地址信息！，自动填充，且不能修改
						this.onDealAddress(data[0])
						this.onDealChangeInvoice(val)
						this.isSelfInput = false
					} else {
						//不存在判断是否为主渠道
						//只要没填，都不能选专票
						this.formInvoice.invoiceType = 2
						let {distAccount = {}} = this.userInfo
						let isMainChannel = false
						if (!this.validatenull(distAccount)) {
							let {channelId = '', mainChannelId = ''} = distAccount
							if (channelId && mainChannelId && channelId === mainChannelId) {
								//主渠道
								isMainChannel = true
							}
						}
						let isHasPermissions = !this.validatenull(this.permissions['dist_recipient_add'])
						if (isMainChannel && isHasPermissions) {
							//主渠道
							this.$alert(
								'接相关保司通知，为了保证您能顺利接收到专票，需要您补充相关邮寄地址信息，感谢您的配合！',
								'信息完善提醒',
								{
									confirmButtonText: '知道了',
								},
							).then(() => {
								//主渠道有权限
								this.$router.push({
									path: this.$router.$avueRouter.getPath({
										src: '/channel/user/editUserInfo',
									}),
								})
							})
						} else {
							//子渠道或者内勤没有数据直接填写
							this.$alert(
								'为了保证专票的高效处理，请您及时通知主渠道管理员完善专票邮寄地址信息，成功完善后可在投保流程中申请专票！',
								'信息完善提醒',
								{
									confirmButtonText: '知道了',
								},
							).then(() => {})
						}
					}
				} else {
					this.formInvoice.invoiceType = 2
					this.$alert('获取专票地址失败，请联系管理员！', '提示', {
						confirmButtonText: '知道了',
					}).then(() => {})
				}

				// let lastTime = new Date('2022-6-5 23:59:59').getTime()
				// let currentTime = new Date().getTime()
				// if (lastTime - currentTime > 0) {
				//     this.formInvoice.invoiceType = 2
				//     if (isClick) {
				//         this.$alert('接保司通知，因上海疫情管控，即日起暂停专票与特殊变更普票的申请，请选择普票!', '警告', {
				//             confirmButtonText: '知道了'
				//         })
				//     }
				// } else {
				//     this.onDealChangeInvoice(val)
				// }
			} else {
				this.onDealChangeInvoice(val)
			}
		},
		//更改开票类型
		onDealChangeInvoice(val) {
			this.optionInvoice.group[0].display = val === 1
			this.optionInvoice.group[0].column.forEach((item, index) => {
				let rules = [
					{
						required: true,
						message: '请输入 ' + item.label,
						trigger: 'blur',
					},
				]
				if (item.prop == 'mailPhone') {
					let ruleMobile = {
						validator: rule.validatorMobile,
						trigger: 'blur',
					}
					rules.push(ruleMobile)
				}
				item.rules = val == 1 ? rules : null
			})
		},
		getSubmitData() {
			let submitData = {
				inv_type: this.formInvoice.invoiceType,
				type: this.formInvoice.invoiceType,
				title: this.formInvoice.title,
				identification: this.formInvoice.identification,
			}

			if (this.formInvoice.invoiceType == 1) {
				let specialData = {}
				if (!this.isZhuanPiaoHide) {
					specialData = {
						identification_z: this.formInvoice.identification,
						address: this.formInvoice.address || '',
						phone: this.formInvoice.phone || '',
						bankName: this.formInvoice.bankName || '',
						bankNo: this.formInvoice.bankNo || '',
						mailName: this.formInvoice.mailName || '',
						mailPhone: this.formInvoice.mailPhone || '',
						mailAreaCode: this.formInvoice.mailAreaCodeArray[2],
						mailAddress: this.formInvoice.mailAddress || '',
						taxCertificate: this.formInvoice.taxCertificate,
						province: this.formInvoice.province || '',
						city: this.formInvoice.city || '',
						district: this.formInvoice.district || '',
						mailAreaName: this.formInvoice.province + this.formInvoice.city + this.formInvoice.district || '',
					}
				} else {
					specialData = {
						identification_z: this.formInvoice.identification,
					}
				}
				Object.assign(submitData, specialData)
			} else {
				Object.assign(submitData, {identification_p: this.formInvoice.identification})
			}

			return submitData
		},
		getData() {
			return this.formInvoice
		},
		setData(data) {
			console.log(data, '---1')

			Object.assign(this.formInvoice, data)

			if (!this.validatenull(data.mailAreaCode)) {
				this.formInvoice.mailAreaCodeArray = this.convertAreaCode(data.mailAreaCode)
			}
			if (!this.validatenull(data.invoiceType)) {
				this.typeChanged(data.invoiceType, false)
			}
			if (this.isSubmitted) {
				this.lockForm(false)
			}
		},
		convertAreaCode(areaCode) {
			let areaCodeArray = []
			if (!this.validatenull(areaCode)) {
				areaCodeArray.push(areaCode.substr(0, 2) + '0000')
				areaCodeArray.push(areaCode.substr(0, 4) + '00')
				areaCodeArray.push(areaCode)
			}
			return areaCodeArray
		},
		//通过接口获取到专票地址处理
		onDealAddress(data = {}) {
			if (!this.validatenull(data)) {
				let {name = '', areaCodes = '', phoneNo = '', address = ''} = data
				this.formInvoice.mailName = name
				this.formInvoice.mailPhone = phoneNo
				this.formInvoice.mailAreaCodeArray = areaCodes.split('|')
				this.formInvoice.mailAddress = address
			}
			//设置不可填写
			this.optionInvoice.group[0].column.forEach((itemData) => {
				let {prop} = itemData
				if (prop === 'mailName' || prop === 'mailPhone' || prop === 'mailAreaCodeArray' || prop === 'mailAddress') {
					itemData.disabled = true
				}
			})
		},
		//"taxType":1--一般纳税人，2--小规模    这么对应 专票 和 普票
		// 1就是普票  2就是专么
		onDealTaxType(taxTypeData = '') {
			//处理发票还是专票
			this.isInvoiceDisabled = taxTypeData !== ''
			if (taxTypeData !== '') {
				let tempType = taxTypeData === '1' ? 1 : 2
				this.typeChanged(tempType)
				this.formInvoice.invoiceType = tempType
			}
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger {
	width: 150px;
	border: transparent;
}
</style>
